<template>
  <div class="view-wrapper content flex-ui">
    <van-nav-bar title="订单确认" left-arrow @click-left="$router.go(-1)" />
    <div class="grow">
      <div class="scroll-content scroll-content-with-footer">
        <div class="address-box" @click="choiseAddress">
          <div class="info">
            <div v-if="orderData.AddressId <= 0">
              <span class="gray">选择地址</span>
            </div>
            <div v-else>
              <div style="margin-bottom:5px;">
                <span class="name">{{ orderData.Name }} {{ orderData.Mobile }}</span>
              </div>
              <div class="addr">{{ orderData.Address }}</div>
            </div>
          </div>
          <div class="arrow">
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="section-group">
          <div v-for="item in products" :key="item.Id" class="goods-item van-hairline--top">
            <div class="goods-box" :class="{ 'disabled': !item.CanSale }">
              <div class="image">
                <img :src="item.ProImage" v-lazy="item.ProImage" alt />
              </div>
              <div class="info">
                <div class="info-item">
                  <div class="info-item-left">
                    <span class="txt-ellipsis2">{{ item.ProName }}</span>
                  </div>
                  <div class="info-item-right pt4">
                    <span class="p-price">&yen;{{ item.StockPrice | num2Filter }}</span>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-item-left">
                    <span class="sku-f">{{ item.StockName }}</span>
                  </div>
                  <div class="info-item-right">
                    <span class="sku-f">x {{ item.Count }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="goods-tip" v-if="item.Desc">
              <van-tag plain type="danger">{{ item.Desc }}</van-tag>
            </div>
          </div>
          <van-cell-group>
            <van-cell>
              <template slot="title">
                <span>商品金额</span>
              </template>
              <span>&yen;{{ totalPrice | num2Filter }}</span>
            </van-cell>
            <van-cell>
              <template #title>
                <span class="custom-title">运费</span>
              </template>
              &yen;{{ orderData.ExpressFee | num2Filter }}
            </van-cell>
            <van-cell>
              <template slot="title">
                <span>合计</span>
              </template>
              <span class="red f16 f-w">&yen;{{ sumPrice | num2Filter }}</span>
            </van-cell>
          </van-cell-group>
        </div>
        <div style="height:20px;"></div>
      </div>
    </div>
    <div class="footer-box">
      <div class="red items">
        <span>&yen;</span>
        <span class="price">{{ sumPrice | num2Filter }}</span>
      </div>
      <div class="btns">
        <van-button round size="large" type="danger" class="btn-default" @click="submitOrder" :loading="payment"
          :disabled="!allChecked" loading-text="提交中...">提交订单</van-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "CartCheckout",
  //   props: ["goods", "product"],
  data () {
    return {
      payment: false,
      expressType: 1,
      addressInfo: {
        Detail: {},
        ExpressFee: 0
      },
      allChecked: false,
      products: [],
      shipping: {
        Fee: 0,
        Desc: '',
        Products: []
      },
      orderData: {
        AddressId: 0,
        Address: "",
        Name: "",
        Mobile: "",
        ExpressFee: 0,
        ExpressType: 1,
        Source: "",
        OrderProducts: []
      }
    };
  },
  computed: {
    totalPrice () {
      let total = 0;
      this.products.forEach(element => {
        if (element.Count > 0) {
          total += element.StockPrice * element.Count;
        }
      });
      return Number(total.toFixed(2));
    },
    sumPrice: function () {
      return (
        Math.round((this.orderData.ExpressFee + this.totalPrice) * 100) / 100);
    },
    orderProducts: function () {
      let products = this.products.filter(item => item.Count > 0 && item.CanSale);
      return products.map(item => {
        return {
          StockId: item.StockId,
          Count: item.Count
        }
      });
    }
  },
  created () {
    //this.initData();
    this.changeAddress();
    this.initData();
  },
  activated () {
    //this.changeAddress();
    this.expressType = 1;
  },
  beforeRouteEnter (to, from, next) {
    //console.log(to, from);
    next(vm => {
      // 通过 `vm` 访问组件实例
      if (from.name === "address" || from.name === "cart") {
        //更改地址
        if (to.query.addressId) {
          vm.orderData.AddressId = to.query.addressId;
        }
        vm.changeAddress();
      }
      if (from.name === "cart") {
        //更新商品
        vm.initData();
      }

    });
  },
  watch: {
    "products": {
      handler (val) {
        this.allChecked = val.every(item => item.CanSale);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initData () {

      this.orderData.Source = this.$store.getters.source;
      //console.log("init");
      this.$toast.loading({
        duration: 0,
        forbidClick: true
      });
      this.$ajax
        .get("/api/cart/order", {
          params: { source: this.orderData.Source }
        })
        .then(response => {
          if (response.data.code === 1) {
            //console.log(response.data.data);
            let data = response.data.data;
            this.products = data;
            // this.products = data.map(item => {
            //   return {
            //     Id: item.Id,
            //     ProName: item.ProName,
            //     ProImage: item.ProImage,
            //     StockName: item.StockName,
            //     ProId: item.ProId,
            //     StockId: item.StockId,
            //     Count: item.Count,
            //     StockPrice: item.StockPrice,
            //     ShippingId: item.ShippingId,
            //     CanSale: item.CanSale,
            //     Desc: item.Desc
            //   }
            // });
            this.calcExpressFeeByTemplate();
          }
          this.$toast.clear();
        });
    },
    choiseAddress () {
      //console.log("选择地址");
      //localStorage.removeItem("checkout_address-id");
      this.$router.push({
        path: "/address",
        query: { type: "checkout", addressId: this.orderData.AddressId }
      });
      //this.orderData.AddressId = -1;
    },
    changeAddress () {
      //选择地址后变更地址信息
      let addressId = localStorage.getItem("checkout_address-id");
      //console.log(addressId);
      let url = addressId
        ? "api/user/address/" + addressId
        : "api/user/address/default";

      //获取地址
      this.$ajax
        .get(url)
        .then(response => {
          if (response.data.code === 1) {
            let address = response.data.data;
            if (address) {
              this.addressInfo.Detail = address;
              //this.addressInfo.ExpressFee = this.calcExpressFee(address.Province, this.productAmount);
              //address.Province === "北京市" ? 15 : 15;
              //this.orderData.ExpressFee = this.calcExpressFee(address.Province, this.productAmount);
              //address.Province === "北京市" ? 15 : 15;


              this.orderData.AddressId = address.Id;
              this.orderData.Name = address.Recipient;
              this.orderData.Mobile = address.Mobile;
              this.orderData.Address = address.Address;
              this.calcExpressFeeByTemplate();
            }
          }
        });
    },
    //接口计算模板运费
    calcExpressFeeByTemplate () {
      this.$toast.loading({
        mask: true,
        message: "加载中...",
        forbidClick: true
      });
      var skus = this.products.map(item => {
        return {
          ProId: item.ProId,
          Count: item.Count,
          Price: item.StockPrice
        }
      })
      this.$ajax
        .post("api/order/calc/expressfee", {
          AddrId: this.orderData.AddressId,
          Products: skus
        }).then(response => {
          if (response.data.code === 1) {
            let d = response.data.data;
            if (d) {
              
              //console.log(d);
              this.shipping = d;
              // this.goods.canSale = d.Products[0].CanSale;
              //运费赋值
              this.orderData.ExpressFee = d.Fee;
              this.addressInfo.ExpressFee = d.Fee;
              //对商品进行校验
              this.products.forEach(item => {
                let p = d.Products.find(p => p.ShippingId === item.ShippingId);
                if (p && item.Status != 1) {
                  item.CanSale = p.CanSale;
                  item.Desc = p.Desc;
                }
              });
            }
          } else {
            //
          }
          this.$toast.clear();
        });
    },
    //提交订单
    submitOrder () {
      if (
        this.orderData.AddressId <= 0 &&
        this.orderData.ExpressType === 1
      ) {
        this.$toast("请选择地址");
        return;
      }
      this.orderData.OrderProducts = this.orderProducts;
      //提交订单
      this.payment = true;
      this.$ajax
        .post("/api/order/create", this.orderData)
        .then(response => {
          this.payment = false;
          if (response.data.code === 1) {
            //success
            if (response.data.data.PayUrl === "") {
              //预约
              this.$router.push({ path: "/order/0" });
            } else {
              this.$toast.loading({
                mask: true,
                message: "跳转支付...",
                forbidClick: true
              });
              window.location.href = response.data.data.PayUrl;
            }
          } else {
            //this.$toast.fail(response.data.message);
            this.$dialog
              .alert({
                title: "下单失败",
                message: response.data.message
              })
              .then(() => {
                // on close
              });
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/base-var.less";

.goods-item {
  background-color: #fff;
}

.goods-box {
  display: flex;
  background: #fff;
  padding: 10px 15px;
  font-size: 16px;
}

.goods-box .image {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  box-shadow: #f2f2f2 0px 0px 8px;
  border-radius: 4px;
}

.goods-box .image img {
  max-width: 100%;
  border-radius: 4px;
}

.goods-box .info {
  flex: 1;
}

.goods-tip {
  padding: 0 15px 5px 100px;
}

.info-item {
  display: flex;
  margin-bottom: 5px;
}

.info-item-right {
  width: 60px;
  text-align: right;
}

.info-item-left {
  flex: 1;
  text-align: left;
}

.p-title {
  font-weight: 500;
}

.p-price {
  color: #f44;
  font-size: 16px;
  font-weight: bold;
}

.sku-f {
  font-size: 12px;
  color: @gray-color;
}

.invoice-box {
  padding: 10px 0;
  background-color: #fff;
}
</style>